<template>
  <div class="page-register">
    <!-- 顶部 Logo + 品牌 -->
    <div class="top-header">
      <img :src="icons.appLogo" class="app-logo" alt="Kukukao" />
      <img :src="icons.logoText" class="logo-text" alt="Kukukao" />
    </div>

    <!-- 标语 + 吉祥物 同一行 -->
    <div class="slogan-row">
      <img :src="icons.slogan" class="slogan-img" alt="每天5分钟 法考学习更轻松" />
      <img :src="icons.mascot" class="mascot-img" alt="" />
    </div>

    <!-- 白色卡片表单 -->
    <div class="card-wrap">
      <div class="card-inner">
        <!-- 立即注册 标题图 -->
        <img :src="icons.registerTitle" class="register-title-img" alt="立即注册" />
        <!-- 手机号 -->
        <div class="form-row">
          <input
            v-model.trim="mobile"
            type="tel"
            maxlength="11"
            placeholder="请输入手机号"
            class="row-input"
            autocomplete="tel"
          />
        </div>
        <div class="row-divider"></div>
        <!-- 验证码 -->
        <div class="form-row">
          <input
            v-model.trim="verifyCode"
            type="text"
            maxlength="6"
            placeholder="请输入验证码"
            class="row-input row-input-code"
            autocomplete="one-time-code"
          />
          <button
            type="button"
            class="btn-send-code"
            :class="{ disabled: !canSendCode || countdown > 0 }"
            :disabled="!canSendCode || countdown > 0"
            @click="handleSendCode"
          >
            {{ countdown > 0 ? `${countdown}s后重发` : '发送验证码' }}
          </button>
        </div>
        <div class="row-divider"></div>

        <!-- 立即注册 -->
        <button
          type="button"
          class="btn-register"
          :class="{ disabled: !canRegister }"
          :disabled="!canRegister || registering"
          @click="handleRegister"
        >
          {{ registering ? '注册中...' : '立即注册' }}
        </button>
      </div>
    </div>

    <!-- 错误/成功提示 -->
    <div v-if="message" class="message" :class="messageType">
      {{ message }}
    </div>
  </div>
</template>

<script>
import appLogo from '@/assets/regiest/appLogo.svg'
import logoText from '@/assets/regiest/logo_text.svg'
import slogan from '@/assets/regiest/slogan.svg'
import mascot from '@/assets/regiest/mascot.svg'
import registerTitle from '@/assets/regiest/title_register.svg'

const MOBILE_REG = /^1\d{10}$/

export default {
  name: 'Register',
  data() {
    return {
      icons: {
        appLogo,
        logoText,
        slogan,
        mascot,
        registerTitle
      },
      mobile: '',
      verifyCode: '',
      countdown: 0,
      timer: null,
      registering: false,
      message: '',
      messageType: 'error' // error | success
    }
  },
  computed: {
    isMobileValid() {
      return MOBILE_REG.test(this.mobile)
    },
    canSendCode() {
      return this.isMobileValid
    },
    canRegister() {
      return this.isMobileValid && this.verifyCode.length >= 4
    },
    promotionUserId() {
      // 优先从路由 query 取（#/register?promotion=xxx）
      const fromRoute = this.$route && this.$route.query && this.$route.query.promotion
      if (fromRoute) return String(fromRoute).trim()
      // 再从进入页面的 URL 参数取（?promotion=xxx#/register 或 ?promotion=xxx）
      if (typeof window === 'undefined') return ''
      const search = window.location.search
      if (search) {
        const params = new URLSearchParams(search)
        const fromSearch = params.get('promotion')
        if (fromSearch) return String(fromSearch).trim()
      }
      const hash = window.location.hash
      const qIndex = hash.indexOf('?')
      if (qIndex !== -1) {
        const params = new URLSearchParams(hash.slice(qIndex))
        const fromHash = params.get('promotion')
        if (fromHash) return String(fromHash).trim()
      }
      return ''
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    showMessage(text, type = 'error') {
      this.message = text
      this.messageType = type
      setTimeout(() => {
        this.message = ''
      }, 3000)
    },
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0 && this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    async handleSendCode() {
      if (!this.canSendCode || this.countdown > 0) return
      const base = process.env.VUE_APP_API_BASE_URL || ''
      try {
        const res = await fetch(`${base}/aliYun/SendSmsVerifyCode`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ mobile: this.mobile })
        })
        const result = await res.json()
        if (result.code === 200) {
          this.startCountdown()
          this.showMessage('验证码已发送', 'success')
        } else {
          this.showMessage(result.message || '发送验证码失败')
        }
      } catch (err) {
        console.error('SendSmsVerifyCode error:', err)
        this.showMessage('网络错误，请稍后重试')
      }
    },
    async handleRegister() {
      if (!this.canRegister || this.registering) return
      const base = process.env.VUE_APP_API_BASE_URL || ''
      this.registering = true
      this.message = ''
      try {
        const res = await fetch(`${base}/aliYun/CheckSmsVerifyCode`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            mobile: this.mobile,
            verifyCode: this.verifyCode,
            promotionUserId: this.promotionUserId
          })
        })
        const result = await res.json()
        if (result.code === 200) {
          this.$router.replace('/register-success')
        } else {
          this.showMessage(result.message || '注册失败')
        }
      } catch (err) {
        console.error('CheckSmsVerifyCode error:', err)
        this.showMessage('网络错误，请稍后重试')
      } finally {
        this.registering = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-register {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0615d 0%, #f08a87 35%, #fff5f5 70%, #ffffff 100%);
  padding: 24px 20px 40px;
  padding-top: calc(24px + env(safe-area-inset-top));
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 16px;
  padding-left: 0;
}

.app-logo {
  width: 40px;
  height: 40px;
  display: block;
}

.logo-text {
  height: 18px;
  width: auto;
  display: block;
}

/* 标语与吉祥物同一行：标语靠左，吉祥物居右 */
.slogan-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: -40px;
  position: relative;
  z-index: 1;
  gap: 12px;
}

.slogan-img {
  max-width: 180px;
  width: 100%;
  height: auto;
  flex-shrink: 0;
  transform: translateY(-20px);
}

.mascot-img {
  width: 140px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.card-wrap {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 2;
}

.card-inner {
  padding: 32px 16px 0;
}

.register-title-img {
  display: block;
  width: 100%;
  max-width: 245px;
  height: auto;
  margin-bottom: 16px;
}

.form-row {
  display: flex;
  align-items: center;
  min-height: 52px;
}

.row-input {
  flex: 1;
  border: none;
  font-size: 15px;
  color: #333;
  outline: none;
  min-width: 0;

  &::placeholder {
    color: #acacac;
  }
}

.row-input-code {
  max-width: 120px;
}

.row-divider {
  height: 1px;
  background: #dddddd;
}

.btn-send-code {
  flex-shrink: 0;
  margin-left: auto;
  padding: 6px 12px;
  font-size: 13px;
  color: #ffb731;
  background: transparent;
  border: none;
  font-weight: 600;
  cursor: pointer;

  &.disabled {
    color: #acacac;
    cursor: not-allowed;
  }
}

.btn-register {
  width: 100%;
  height: 48px;
  margin: 24px 0 20px;
  border: none;
  border-radius: 16px;
  background: #f0615d;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(240, 97, 93, 0.3);

  &:active:not(.disabled) {
    opacity: 0.9;
    transform: scale(0.99);
  }

  &.disabled {
    background: #dddddd;
    color: #999;
    cursor: not-allowed;
    box-shadow: none;
  }
}

.message {
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  padding: 8px 16px;

  &.error {
    color: #f0615d;
  }

  &.success {
    color: #52c41a;
  }
}
</style>
